/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios;

import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput);

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

//Moment.js
import moment from 'moment-timezone'
moment.tz.setDefault("SI");
Vue.prototype.moment = moment;

// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer);


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css');


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false;

let loadStatus = 0;

axios.get('/api/listing/v1/categories/navItems').then(function (response) {
    store.dispatch('setNavTree', response.data);
    loadStatus++;
    loadVue();
}).catch(function () {
});

axios.get('/api/management/v1/ping').then(function () {
    store.dispatch('setCompanyAdminStatus', true);
    loadStatus++;
    loadVue();
}).catch(function () {
    store.dispatch('setCompanyAdminStatus', false);
    loadStatus++;
    loadVue();
});

axios.get('/api/order/v1/ping').then(function () {
    store.dispatch('setLoggedInStatus', true);
    loadStatus++;
    loadVue();
}).catch(function () {
    store.dispatch('setLoggedInStatus', false);
    loadStatus++;
    loadVue();
});

function loadVue() {

    if(loadStatus < 3) return;

    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            store.dispatch('setLoggedInStatus', false);
        }
        if (error.response.status === 403 && !error.request.includes("ping")) {
            router.push('/')
        }
        return Promise.reject(error)
    });

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');

}
